/* =========================================================
   DearRoot — Buy box V2 (DearRoot-style tiered offer)
   gift-unlock bar • savings copy • ATC with free gifts
   Bundle selection/pricing itself is handled by dr-product.js;
   this file layers tier-aware behavior on top.
   ========================================================= */
(function () {
  'use strict';

  // Same presentment-currency formatting approach as dr-product.js
  const _cfg = window.DR_CFG || {};
  let _nfInt = null, _nfDec = null;
  try {
    const base = { style: 'currency', currency: _cfg.currency || 'USD' };
    _nfInt = new Intl.NumberFormat(_cfg.locale || 'en', Object.assign({ minimumFractionDigits: 0, maximumFractionDigits: 0 }, base));
    _nfDec = new Intl.NumberFormat(_cfg.locale || 'en', Object.assign({ minimumFractionDigits: 2, maximumFractionDigits: 2 }, base));
  } catch (e) { _nfInt = _nfDec = null; }
  // Whole dollars drop the ".00"; anything fractional keeps 2 digits ($504.90, not $504.9)
  const money = n => {
    const whole = Math.round(n * 100) % 100 === 0;
    const nf = whole ? _nfInt : _nfDec;
    return nf ? nf.format(n) : '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  };
  const cents = c => money((+c || 0) / 100);
  const roundedCents = c => cents(Math.round((+c || 0) / 100) * 100);

  function init() {
    const root = document.querySelector('.bb-v2');
    if (!root) return;
    const bundles = [...root.querySelectorAll('.bundle')];
    if (!bundles.length) return;
    const cfg = window.DR_BB2 || {};
    const subscriptionOnly = cfg.subscriptionOnly === true || root.dataset.subscriptionOnly === 'true';
    const gifts = cfg.gifts || [];
    const gbItems = [...root.querySelectorAll('.gb-item')];

    const selectedBundle = () => bundles.find(b => b.getAttribute('aria-checked') === 'true');
    const tierOf = () => {
      const s = selectedBundle();
      return s ? +s.dataset.tier || 1 : 1;
    };

    // Subscription price is the default display (dr-product.js boots in
    // 'sub' mode); one-time price backs the express-checkout link below.
    const priceOf = b => subscriptionOnly ? (+b.dataset.sub || 0) : (+b.dataset.sub || +b.dataset.once || 0);

    // DearRoot-style savings copy vs the anchor compare price: "You save $X"
    // per card, and the anchor (not the one-time price) as the strikethrough.
    // Overwrites what dr-product.js paints once at its init.
    function paintSavings() {
      bundles.forEach(b => {
        const compare = +b.dataset.compare || 0;
        const save = compare - priceOf(b);
        const saveEl = b.querySelector('.b-save');
        const wasEl = b.querySelector('.b-was');
        if (saveEl) {
          if (save > 0) { saveEl.textContent = 'You save ' + cents(save); saveEl.style.display = ''; }
          else saveEl.style.display = 'none';
        }
        if (wasEl) {
          if (compare > priceOf(b)) { wasEl.textContent = cents(compare); wasEl.style.display = ''; }
          else wasEl.style.display = 'none';
        }
      });
    }

    // Selected-tier copy: sale pill ("FALL SALE - Save $X"), anchor
    // strikethrough next to the price, and the one-time purchase price.
    // Overwrites the "% OFF"/one-time-was text dr-product.js paints on selection.
    function paintSelected() {
      const s = selectedBundle();
      if (!s) return;
      const refill = root.querySelector('[data-subscription-refill]');
      if (refill) refill.textContent = s.dataset.plan
        ? 'Ships every 28 days - free shipping'
        : 'Subscription unavailable';
      const giftBenefit = root.querySelector('[data-subscription-gifts]');
      if (giftBenefit) giftBenefit.hidden = !s.dataset.plan || !gifts.slice(0, Math.max(0, tierOf() - 1)).some(g => g && g.id);
      const compare = +s.dataset.compare || 0;
      const save = compare - priceOf(s);
      const off = document.getElementById('atcOff');
      if (off) {
        if (save > 0) { off.textContent = (cfg.saleLabel || 'SALE') + ' - Save ' + roundedCents(save); off.style.display = ''; }
        else off.style.display = 'none';
      }
      const was = document.getElementById('atcWas');
      if (was) {
        if (compare > priceOf(s)) { was.textContent = cents(compare); was.style.display = ''; }
        else was.style.display = 'none';
      }
      const buttonWas = document.getElementById('atcButtonWas');
      const buttonNow = document.getElementById('atcButtonNow');
      if (buttonWas) {
        if (compare > priceOf(s)) { buttonWas.textContent = cents(compare); buttonWas.style.display = ''; }
        else buttonWas.style.display = 'none';
      }
      if (buttonNow) buttonNow.textContent = cents(priceOf(s));
      const otp = document.getElementById('otpPrice');
      if (otp) otp.textContent = cents(+s.dataset.once || 0);
      const shipping = root.querySelector('[data-otp-shipping]');
      const currencyRate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      if (shipping) shipping.textContent = cents(Math.round(495 * currencyRate));
    }

    // Tier hero: selecting tier 2/3 swaps the featured slide + first thumb
    // to that tier's composite image; tier 1 restores the original.
    const tierHero = cfg.tierHero || {};
    let heroOrig = null;
    function paintHero() {
      const track = document.getElementById('galTrack');
      const slideImg = track && track.querySelector('.gal-slide img');
      const thumbBtn = root.querySelector('.gal-thumb');
      const thumbImg = thumbBtn && thumbBtn.querySelector('img');
      if (!slideImg || !thumbImg) return;
      if (!heroOrig) heroOrig = {
        src: slideImg.src, srcset: slideImg.getAttribute('srcset'),
        thumbSrc: thumbImg.src, full: thumbBtn.dataset.full || ''
      };
      const url = tierHero[String(tierOf())];
      const changed = url ? slideImg.src !== url : slideImg.src !== heroOrig.src;
      if (url) {
        slideImg.src = url; slideImg.removeAttribute('srcset');
        thumbImg.src = url; thumbBtn.dataset.full = url;
      } else {
        slideImg.src = heroOrig.src;
        if (heroOrig.srcset) slideImg.setAttribute('srcset', heroOrig.srcset);
        thumbImg.src = heroOrig.thumbSrc; thumbBtn.dataset.full = heroOrig.full;
      }
      // bring the featured slide into view so the swap is visible
      if (changed && track) track.scrollTo({ left: 0, behavior: 'smooth' });
    }

    function paintGifts() {
      const t = tierOf();
      gbItems.forEach(it => it.classList.toggle('locked', t < +it.dataset.unlock));
      paintSelected();
      paintHero();
    }

    // React to any selection change dr-product.js makes (click, keyboard,
    // init). Observer callbacks run after selectBundle/paintATC complete,
    // so the copy rewrites above always win.
    const mo = new MutationObserver(paintGifts);
    bundles.forEach(b => mo.observe(b, { attributes: true, attributeFilter: ['aria-checked'] }));

    // Pre-select a tier: ?count=N (DearRoot-style link param) wins, then the
    // section's default tier. dr-product.js's own ?bundle=N param is respected.
    // The click only lands once dr-product.js has bound its handlers, and
    // script ordering isn't guaranteed — verify via aria-checked and retry.
    const params = new URLSearchParams(location.search);
    const count = +params.get('count');
    let want = null;
    if (count && bundles[count - 1]) want = bundles[count - 1];
    else if (!params.get('bundle') && cfg.defaultTier && bundles[cfg.defaultTier - 1]) want = bundles[cfg.defaultTier - 1];
    (function preselect(tries) {
      if (!want || want.getAttribute('aria-checked') === 'true') return;
      want.click();
      if (want.getAttribute('aria-checked') !== 'true' && tries > 0) setTimeout(() => preselect(tries - 1), 60);
    })(20);
    if (subscriptionOnly) {
      bundles.forEach(b => {
        const available = !!(b.dataset.plan && b.dataset.sub);
        b.classList.toggle('subscription-unavailable', !available);
        b.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    }
    paintSavings();
    paintGifts();

    // Gift line items the selected tier unlocks (tier 2 → gift 1, tier 3 →
    // gifts 1+2; nulls = messaging-only gifts). Gifts deliberately have no
    // selling_plan: they ship with the initial order only, never on renewals.
    const giftItems = () => {
      const t = tierOf();
      return gifts.slice(0, Math.max(0, t - 1)).filter(g => g && g.id).map(g => ({ id: g.id, quantity: 1 }));
    };

    // Express checkout: add the items, then go straight to /checkout.
    // Falls back to the cart drawer (with its error toast) if the add fails.
    function expressCheckout(btn, items) {
      btn.classList.add('is-loading');
      const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      }).then(async r => {
        if (!r.ok) throw new Error('cart');
        if (window.DR && DR.reconcileCartGifts) {
          try { await DR.reconcileCartGifts(); } catch (e) {
            btn.classList.remove('is-loading');
            DR.toast('Please try again before checking out.');
            return;
          }
        }
        window.location.href = '/checkout';
      }).catch(() => {
        btn.classList.remove('is-loading');
        if (window.DR && DR.cartAdd) DR.cartAdd(items);
      });
    }

    // Add to cart: selected variant on its subscription plan (default) +
    // the tier's free gifts, straight to checkout.
    root.querySelectorAll('[data-add-v2]').forEach(btn => btn.addEventListener('click', () => {
      const s = selectedBundle();
      if (!s || !s.dataset.variant) return;
      const item = { id: +s.dataset.variant, quantity: 1 };
      if (subscriptionOnly) {
        if (!(s.dataset.plan && s.dataset.sub)) return;
        item.selling_plan = +s.dataset.plan;
      } else if (s.dataset.plan && s.dataset.sub) {
        item.selling_plan = +s.dataset.plan;
      }
      expressCheckout(btn, [item].concat(giftItems()));
    }));

    // One Time Purchase: same flow without the selling plan.
    root.querySelectorAll('[data-otp]').forEach(btn => btn.addEventListener('click', () => {
      const s = selectedBundle();
      if (!s || !s.dataset.variant) return;
      expressCheckout(btn, [{ id: +s.dataset.variant, quantity: 1 }]);
    }));

    // Animate the stock bar fill on load
    const fill = root.querySelector('.sa-fill');
    if (fill) requestAnimationFrame(() => requestAnimationFrame(() => fill.classList.add('go')));
  }

  // Deferred scripts run at readyState 'interactive', and dr-product.js
  // (which binds the bundle click handlers) executes after this file in
  // document order — so wait for DOMContentLoaded before layering on top.
  if (document.readyState === 'complete') init();
  else {
    let done = false;
    const run = () => { if (!done) { done = true; init(); } };
    document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
  }
})();
